(() => {
  if (window.aquabossBrassInit) { window.aquabossBrassInit(); return; }
  const init = () => document.querySelectorAll('[data-brass-carousel]').forEach(root => {
    if (root.dataset.brassReady) return;
    root.dataset.brassReady = 'true';
    const track = root.querySelector('[data-brass-track]');
    const originals = [...track.children];
    const count = originals.length;
    const reduced = matchMedia('(prefers-reduced-motion:reduce)');
    let paused = reduced.matches, hovering = false, focused = false, visible = false;
    let index = count, frame = 0, settle = 0, resumeAt = 0, dragging = null;
    const clone = slide => {
      const copy = slide.cloneNode(true);
      copy.setAttribute('aria-hidden', 'true');
      copy.removeAttribute('id');
      return copy;
    };
    track.prepend(...originals.map(clone));
    track.append(...originals.map(clone));
    const slides = [...track.children];
    const step = () => originals[0].offsetWidth;
    const paint = () => {
      frame = 0;
      const position = track.scrollLeft / step();
      index = Math.max(0, Math.min(slides.length - 1, Math.round(position)));
      slides.forEach((slide, i) => {
        const focus = Math.max(0, 1 - Math.abs(i - position));
        slide.style.setProperty('--brass-scale', String(.68 + focus * .32));
        slide.style.setProperty('--brass-opacity', String(.35 + focus * .65));
      });
    };
    const jump = target => {
      track.style.scrollSnapType = 'none';
      track.scrollLeft = target * step();
      index = target;
      track.style.scrollSnapType = '';
      paint();
    };
    const move = delta => {
      track.scrollTo({ left: (index + delta) * step(), behavior: reduced.matches ? 'instant' : 'smooth' });
    };
    const interact = () => { resumeAt = Date.now() + 6500; };
    track.addEventListener('scroll', () => {
      if (!frame) frame = requestAnimationFrame(paint);
      clearTimeout(settle);
      settle = setTimeout(() => {
        if (dragging) return;
        if (index < count) jump(index + count);
        else if (index >= count * 2) jump(index - count);
      }, 180);
    }, { passive: true });
    track.addEventListener('wheel', interact, { passive: true });
    track.addEventListener('pointerdown', e => {
      interact();
      if (e.pointerType !== 'mouse') return;
      dragging = { x: e.clientX, left: track.scrollLeft };
      track.setPointerCapture(e.pointerId);
      track.style.scrollSnapType = 'none';
    });
    track.addEventListener('pointermove', e => {
      if (dragging) track.scrollLeft = dragging.left + dragging.x - e.clientX;
    });
    const release = () => {
      if (!dragging) return;
      dragging = null; track.style.scrollSnapType = ''; paint(); move(0); interact();
    };
    track.addEventListener('pointerup', release);
    track.addEventListener('pointercancel', release);
    track.addEventListener('keydown', e => {
      if (e.key === 'ArrowRight' || e.key === 'ArrowLeft') {
        e.preventDefault(); interact(); move(e.key === 'ArrowRight' ? 1 : -1);
      }
    });
    root.querySelector('[data-brass-prev]').addEventListener('click', () => { interact(); move(-1); });
    root.querySelector('[data-brass-next]').addEventListener('click', () => { interact(); move(1); });
    root.addEventListener('mouseenter', () => { hovering = true; });
    root.addEventListener('mouseleave', () => { hovering = false; });
    root.addEventListener('focusin', () => { focused = true; });
    root.addEventListener('focusout', e => { focused = root.contains(e.relatedTarget); });
    reduced.addEventListener('change', () => { paused = reduced.matches; });
    const observer = new IntersectionObserver(entries => { visible = entries[0].isIntersecting; }, { threshold: .25 });
    observer.observe(root);
    const resize = new ResizeObserver(() => jump(count + index % count));
    resize.observe(track);
    jump(count);
    const timer = setInterval(() => {
      if (!root.isConnected) {
        clearInterval(timer); clearTimeout(settle); cancelAnimationFrame(frame); observer.disconnect(); resize.disconnect(); return;
      }
      if (!paused && !hovering && !focused && visible && !document.hidden && Date.now() > resumeAt) move(1);
    }, 2000);
  });
  window.aquabossBrassInit = init;
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
  else init();
  document.addEventListener('shopify:section:load', init);
})();
